




























































































































import _ from 'lodash';
import {Component, Mixins, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import NumberGenerator from "@/common/mixins/numberGenerator";
import AllYouCanEatDrink from "@/common/mixins/allYouCanDrinkEat";
import QDetailModal from "@/components/qDetailModal.vue";
import Order from "@/model/order";
import Menu from "@/model/menu";
import store from "@/store";
import $ from "jquery";
import { DATETIME_FORMAT, NO_IMAGE_URL } from "@/common/constant";
import System from "@/model/system";
import orderApi from "@/api/orderApi";
import moment from "moment/moment";
import { ReloadManager } from '@/common/util/reloadManager';

const orderStore = namespace("OrderStore")
const systemStore = namespace("SystemStore")
const menuStore = namespace("MenuStore")
const languageStore = namespace("LanguageStore")

let reloadTableId = null;

@Component({
  name: "OrderComponent",
  components: {QDetailModal},
})
export default class OrderComponent extends Mixins(NumberGenerator, AllYouCanEatDrink) {
  @orderStore.Getter
  getOrderList!: Order[];
  @systemStore.Getter
  getSystem!: System;
  @systemStore.Getter
  isCloseAYCConfirm: boolean;
  @systemStore.Action
  setCloseAYCConfirm;
  @menuStore.Getter
  getRawMenuList!: Menu[];
  @languageStore.Getter
  getMenuNameKey: string

  public isShowLimitNotification = false;
  public baseTime: Date = new Date();
  public active = false;
  public isOrder = false;
  private isQtyErr = false;
  private qtyErrMenu = '';
  private qtyErrNum = 0;
  public noImageUrl = NO_IMAGE_URL;

  created() {
    // ticker for display relative time
    console.log("start ticker");
    const reloadManager = ReloadManager.load(this.getSystem);
    reloadManager.getTables();
    clearTimeout(reloadTableId);
    reloadTableId = setTimeout(this.reloadTable.bind(this), 60 * 1000);
  }

  private reloadTable () {
    this.baseTime = new Date();
    clearTimeout(reloadTableId);
    reloadTableId = setTimeout(this.reloadTable.bind(this), 60 * 1000);
  }

  private get namekey() {
    return this.getMenuNameKey;
  }

  get elapsedMinute(): number {
    return this.getTable.getElapsedMinute(this.baseTime);
  }
  get remainMinute(): number {
    return this.getTable.getRemainMinute();
  }

  get isDisplayLimit(): boolean {
    const table = this.getTable;
    if (table == null || table.tables[0] == undefined) {
      return false;
    }

    // check shop setting
    const isDisplayLimit = table?.tables[0]?.displayLimit == 1;
    if (!isDisplayLimit) {
      return false;
    }

    return this.isActiveAllYouCanDrink || this.isActiveAllYouCanEat;
  }

  get remain() {
    const remain =  this.getTable.getRemainMinute();
    return (remain > 0) ? this.getTable.getRemainMinute() : 0;
  }

  get limitAlertTime(): string {
    if(!this.isDisplayLimit) {
      return "---";
    }

    const table = this.getTable;

    const notificationLimit = Number.parseInt(table.tables[0].limitAlertTime);

    if (!this.isCloseAYCConfirm && this.remain <= notificationLimit)
    {
      this.isShowLimitNotification = true;
    }

    return this.remain <= 0 ? "---" : this.remain.toString();
  }

  get orderList() {
    if (this.getOrderList.length === 0) {
      this.updateOrderAction()
    } else {
      document.body.setAttribute("order","")
    }

    return this.getOrderList
  }

  private closeAYCConfirm() {
    this.isShowLimitNotification = false
    this.setCloseAYCConfirm();
  }

  displayOrderList() {
    return this.getOrderList.length === 0;
  }

  private closeEvent() {
    if (this.$router.currentRoute.hash === "") {
      this.active = false;
      $('.js__menu-list').slideUp();
      removeEventListener("popstate", this.closeEvent);
    }
  }

  @Watch("active")
  changeActive() {
    if (this.active) {
      addEventListener("popstate", this.closeEvent);
      this.$router.push({ "hash" : "openCart" });
    } else {
      if (this.$router.currentRoute.hash === "#openCart") {
        this.$router.back();
      }
    }
  }

  public toggleOrderList() {
    this.active = !this.active;
    $('.js__menu-list').slideToggle();
  }

  get recommendation(): Menu {
    const alreadyInCartIds = new Set(_.map(this.getOrderList, menu => menu.identifier));

    const filtered = _.filter(this.getRawMenuList, (menu: Menu) => {
      if (menu.soldOut) {
        return false;
      }
      if (alreadyInCartIds.has(menu.identifier)) {
        return false;
      }

      return (menu.anotherShowMinuteFrom <= this.elapsedMinute && this.elapsedMinute <= menu.anotherShowMinuteTo);
    });

    if (filtered.length === 0) {
      return new Menu();
    }

    return _.first(filtered);
  }

  public openMenuDetail(menu, isEdit = false) {
    this.detailModal(menu, isEdit);
  }

  public detailModal(menu, isEdit) {
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }

  public getTotalQuantity() {
    let totalQuantity = 0;
    if (this.orderList === null) {
      return totalQuantity
    } else {
      this.orderList.map(value => {
        totalQuantity += value.quantity
      })
    }

    return totalQuantity
  }

  public getTotalPrice() {
    let totalPrice = 0;
    if (this.orderList === null) {
      return totalPrice
    } else {
      this.orderList.map(order => {
        if (order.options?.length > 0) {
          // eslint-disable-next-line unicorn/no-array-reduce
          let optionTotal = order.options.reduce((optionsSum, optionSet) => {
            // eslint-disable-next-line unicorn/no-array-reduce
            return optionsSum + optionSet.options.reduce((sum, option) => {
              return sum + option.quantity * option.price;
            }, 0);
          }, 0);
          totalPrice += optionTotal
        }
        if (this.isFreeMenu(order.menuDetail)) {
          return 0;
        }

        totalPrice += order.quantity * order.price
      })
    }

    return this.getPriceFormat(totalPrice)
  }

  getOptions(order) {
    let options = [];
    order.options.filter(item => {
      item.options.filter(option => {
        if (option.quantity > 0) {
          options.push({
            'identifier' : option.identifier,
            'name' : option.name,
            'quantity' : option.quantity,
            'price' : option.price,
          })
        }
      });
    });

    return options;
  }

  async submitOrder() {
    const time = moment().format(DATETIME_FORMAT);
    let data = {
      "act": "register",
      "mtd": "register",
      "jda_ins_date": [],
      "jda_set_menus": [],
      "jda_smcd": [],
      "jda_smcd_sub1": [],
      "jda_smnmj": [],
      "jda_suryo": [],
      "jda_tanka": []
    }

    this.orderList.map((order) => {
      if (order.options.length > 0) {

        // parent item
        data.jda_set_menus.push("1");
        data.jda_smcd.push(order.identifier);
        data.jda_smnmj.push(order.name);
        data.jda_suryo.push(order.quantity);
        data.jda_tanka.push(order.price);
        data.jda_ins_date.push(time);
        data.jda_smcd_sub1.push(order.subIdentifier ?? "");

        const optionsList = this.getOptions(order);
        optionsList.filter(item => {
          data.jda_set_menus.push("2");
          data.jda_smcd.push(item.identifier);
          data.jda_smnmj.push(item.name);
          data.jda_suryo.push(item.quantity);
          data.jda_tanka.push(item.price);
          data.jda_ins_date.push(time);
          data.jda_smcd_sub1.push(order.subIdentifier ?? "");
        });
      } else if (order.subMenus.length > 0) {
        for (const subMenu of order.subMenus) {
          if (subMenu.quantity > 0) {
            data.jda_ins_date.push(time);
            data.jda_set_menus.push("0");
            data.jda_smcd.push(subMenu.identifier);
            data.jda_smcd_sub1.push(subMenu.subIdentifier ?? "");
            data.jda_smnmj.push(order.name + '(' + subMenu.subName + ')');
            data.jda_suryo.push(subMenu.quantity);
            data.jda_tanka.push(order.price);
          }
        }
      } else {
        data.jda_ins_date.push(time);
        data.jda_set_menus.push("0");
        data.jda_smcd.push(order.identifier);
        data.jda_smcd_sub1.push(order.subIdentifier ?? "");
        data.jda_smnmj.push(order.name);
        data.jda_suryo.push(order.quantity);
        data.jda_tanka.push(order.price);
      }
    })

    const response = await orderApi.store(data)
    if (!response) {
      return;
    }
    if (response.status === 200 && response.data.code === 200200200) {
      const context = JSON.parse(response.data.context)
      if (context.data?.quantity_check?.length > 0) {
        this.qtyErrMenu = this.getRawMenuList.find((menu) => {
          return menu.identifier == context.data.quantity_check[0].identifier
        })?.name;
        this.qtyErrNum = context.data.quantity_check[0].quantity
        this.isQtyErr = true;
        return;
      }
      // reset all Store Module
      this.orderList.map((order) => {
        store.dispatch('OrderStore/clearList')
        if (order.options.length > 0) {
          order.options.map(option => {
            option.quantity = 0
            store.dispatch('OptionStore/editOptionToList', option)
          })
        }
      })

      this.updateOrderAction()
      store.dispatch('MenuStore/clearQuantity');
      store.dispatch('OptionStore/clearQuantity');

      this.isOrder = true;
      await this.sleep(5 * 1000)
      this.isOrder = false;
    }
  }

  async sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private updateOrderAction() {
    if (this.active === true) {
      this.active = false;
      document.body.setAttribute("order","none")
      $('.js__menu-list').slideToggle();
    }
  }

  animationOrderListTitle () {
    return ! this.active ? 'on' : '';
  }
  animationOrderBtnBox () {
    return this.active ? 'on' : '';
  }
}
